<pub-notification></pub-notification>
<pub-cookies-policy-modal></pub-cookies-policy-modal>
<div class="main-container h-full">
  <ng-template #containerRef></ng-template>
</div>

